module.exports = __webpack_public_path__ + "static/media/desk.cebd7470.png";